import { useState } from 'react';
import { Modal } from 'react-bootstrap';
import RecordOrUploadModal from '../RecordOrUploadModal';

const STUDIO_PROMPT_INDEX = 0;

type PromptVideoRecordingModalProps = {
  show: boolean;
  promptText: string;
  onHide: () => void;
  onVideoCaptured: (file: File) => void;
};

/** Unified recording studio — same UI/behavior as /create-prompt. */
export function PromptVideoRecordingModal({
  show,
  promptText,
  onHide,
  onVideoCaptured,
}: PromptVideoRecordingModalProps) {
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [videoFiles, setVideoFiles] = useState<Record<number, File>>({});

  const handleClose = () => {
    setVideoFiles({});
    setErrors({});
    onHide();
  };

  const handleVideoCaptured = (file: File) => {
    onVideoCaptured(file);
    handleClose();
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      className="recording-studio-modal"
      backdropClassName="recording-studio-modal-backdrop"
    >
      <RecordOrUploadModal
        key={show ? `studio-${promptText}` : 'studio-closed'}
        openPromptIndex={STUDIO_PROMPT_INDEX}
        editingIndex={STUDIO_PROMPT_INDEX}
        recordOrUploadModal={show}
        onModalClose={handleClose}
        errors={errors}
        setErrors={setErrors}
        videoFiles={videoFiles}
        setVideoFiles={setVideoFiles}
        hideSubmit
        preferRecordingStudio
        studioOnly
        promptText={promptText}
        onVideoCaptured={handleVideoCaptured}
      />
    </Modal>
  );
}

export default PromptVideoRecordingModal;
